import { useQuery } from "@tanstack/react-query";

import { httpClient } from "@/lib/http";
import { HttpResponse, User } from "@/types";

export function useGetUser({ userId }: { userId: number }) {
  return useQuery({
    queryKey: ["users", userId],
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      const path = `users/${userId}`;
      const res = await httpClient.get<User, HttpResponse<User>>(path);
      return res.data;
    },
  });
}
